export default {
      id: "management-usage",
      viewBox: "0 0 24.75 31.02",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#management",
      toString: function () {
        return this.url;
      }
    }